var siteMap = {
    Path: '/',
    ForgotPassword: {
        Path: '/forgotpassword'
    },
    TemporaryPassword: {
        Path: '/temporarypassword'
    },
    NewPassword: {
        Path: '/newpassword'
    },
    ResetPassword: {
        Path: '/resetpassword'
    },
    ConnectYourAccount: {
        Path: '/connectyouraccount'
    },
    PasswordlessRegister: {
        Path: '/passwordlessregister'
    }
};
export var SiteMap = siteMap;
